module.exports = __webpack_public_path__ + "media/images/pepsi-coke--shared-43f4681338f131d408dfc19f2ff1525a.svg";